export function getOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || "";

  if (/android/i.test(userAgent)) {
    return "ANDROID";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "IOS";
  }

  return "Unknown";
}

export function getDeviceIdSuffix() {
  const os = getOperatingSystem();
  return os === "IOS" || os === "ANDROID" ? os : "ANDROID";
}
